/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.getElementById('Facet-Drawer');
  }
  connectedCallback() {
    this.addEventListener('click', () => {
      document.body.classList.toggle('open-cc');
      this.drawer.classList.toggle('active');
      this.drawer.removeAttribute('inert');
    });
  }
}
customElements.define('facet-toggle', FacetsToggle);

/**
 *  @class
 *  @function SidebarToggle
 */
class SidebarToggle extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const span = this.querySelector('span');
    const hideFilters = span.textContent;

    this.addEventListener('click', (e) => {
      e.preventDefault();
      this.drawer = document.getElementById('Sidebar-Container');
      this.drawer.classList.toggle('facets--sidebar-open');

      span.textContent = this.drawer.classList.contains('facets--sidebar-open') ? hideFilters : theme.strings.showFilters;
    });
  }
}
customElements.define('sidebar-toggle', SidebarToggle);
/**
 *  @class
 *  @function FacetFiltersForm
 */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }
  connectedCallback() {
    this.querySelectorAll('.thb-filter-content--button').forEach((more_button) => {
      more_button.addEventListener('click', this.onMore);
    });
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.querySelectorAll('.thb-filter-count, .mobile-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.products').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');

    const update = () => {
      container.innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

      ScrollTrigger.batch('.animations-true .products .product-card--image-primary', {
        start: "top 90%",
        onEnter: (elements) => {
          gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
        }
      });
      container.querySelectorAll('.lazyload').forEach((image) => {
        lazySizes.loader.unveil(image);
      });

      // Calzados Modesto®: tras pintar el nuevo listado, ocultar los productos
      // que no tienen stock real en la talla/color filtrados
      requestAnimationFrame(() => {
        FacetFiltersForm.applyAvailabilityFilter();
      });
    };
    const scrollToGrid = () => {
      let top = container.getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

      window.scrollTo({
        top: top,
        left: 0,
        behavior: "smooth"
      });
    };

    // Progressive enhancement: crossfade the grid swap where the View
    // Transitions API exists. The animations-true gate covers both the
    // merchant animations setting and prefers-reduced-motion (which flips
    // the body class at load). Scroll runs after the transition so smooth
    // scrolling doesn't fight the snapshot overlay.
    if (document.startViewTransition && document.body.classList.contains('animations-true')) {
      document.startViewTransition(update).finished.then(scrollToGrid);
    } else {
      update();
      scrollToGrid();
    }
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);


    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      document.querySelector(selector).classList.remove('loading');
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  /**
   * Calzados Modesto® — filtro por stock real.
   * Shopify devuelve un producto si TIENE la variante filtrada, aunque esté
   * agotada. Aquí se ocultan los que no tienen stock en los valores filtrados,
   * usando los atributos data-avail-* que pinta product-card.liquid
   * (p. ej. data-avail-talla="36|38|40|", solo variantes con stock).
   * Es síncrono, sin peticiones. Después recalcula el contador de productos.
   */
  static applyAvailabilityFilter() {
    const searchParams = new URLSearchParams(window.location.search);

    // Filtros de opción activos: { talla: ['38'], color: ['negro'] }
    const optionFilters = {};
    for (const [key, value] of searchParams.entries()) {
      if (key.startsWith('filter.v.option.')) {
        const optName = key.replace('filter.v.option.', '').toLowerCase().replace(/ /g, '-');
        if (!optionFilters[optName]) optionFilters[optName] = [];
        optionFilters[optName].push(value.toLowerCase());
      }
    }

    // Sin filtros de opción: mostrar todo y no tocar el contador
    if (Object.keys(optionFilters).length === 0) {
      document.querySelectorAll('.products--column').forEach((col) => {
        col.style.display = '';
      });
      return;
    }

    let visibles = 0;
    document.querySelectorAll('.products--column').forEach((col) => {
      const card = col.querySelector('product-card');
      if (!card) return;

      let shouldHide = false;

      for (const [filterOptName, filterValues] of Object.entries(optionFilters)) {
        const availStr = card.getAttribute('data-avail-' + filterOptName);

        // El producto no tiene esta opción: se oculta
        if (availStr === null || availStr === '') {
          shouldHide = true;
          break;
        }

        // Valores con stock de esta opción
        const availValues = availStr.toLowerCase().split('|').filter((v) => v !== '');

        // Dentro de una misma opción basta con que coincida UNO de los valores marcados
        if (!filterValues.some((fv) => availValues.includes(fv))) {
          shouldHide = true;
          break;
        }
      }

      col.style.display = shouldHide ? 'none' : '';
      if (!shouldHide) visibles++;
    });

    FacetFiltersForm.updateProductCount(visibles);
  }

  /**
   * Calzados Modesto® — pone en el contador el número real de productos
   * visibles tras el filtro de stock.
   */
  static updateProductCount(visibles) {
    const labels = document.querySelectorAll('.thb-filter-count .facets__label, .mobile-filter-count .facets__label');
    labels.forEach((label) => {
      const palabra = visibles === 1 ? 'producto' : 'productos';
      label.textContent = `${visibles} ${palabra}`;
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const triggerForm = event.target.closest('form');
    const formData = new FormData(triggerForm);
    const searchParams = new URLSearchParams(formData);

    // Calzados Modesto®: copiar lo marcado al resto de formularios de filtros
    // (escritorio y móvil), para que no se pierdan filtros al combinar varios
    document.querySelectorAll('facet-filters-form').forEach((facetForm) => {
      facetForm.querySelectorAll('form').forEach((form) => {
        if (form === triggerForm) return;
        form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((input) => {
          const matchingInput = triggerForm.querySelector(`input[name="${CSS.escape(input.name)}"][value="${CSS.escape(input.value)}"]`);
          if (matchingInput) input.checked = matchingInput.checked;
        });
      });
    });
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  onMore(e) {
    let ul = this.closest('.thb-filter-content').querySelector('ul');

    if (ul.hasAttribute('filters-open')) {
      this.textContent = theme.strings.showMore;
      ul.removeAttribute('filters-open');
    } else {
      this.textContent = theme.strings.showLess;
      ul.setAttribute('filters-open', '');
    }
    e.preventDefault();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/**
 *  @class
 *  @function FacetRemove
 */
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);


/**
 *  @class
 *  @function FacetToolbar
 */
class FacetToolbar extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.productGrid = this.closest('#ProductGridContainer');
    this.compareToggle = this.querySelector('#compare_toggle');
    this.layoutSwitcher = this.querySelector('.facets--bar-view-as');
    this.buttons = this.querySelectorAll('.facets--bar-view-as-button');
    this.productLayout = window.localStorage.getItem('product-layout');
    if (this.layoutSwitcher) {
      this.buttons.forEach((button) => {
        button.addEventListener('click', (evt) => {
          [].forEach.call(this.buttons, function (el) {
            el.removeAttribute('disabled');
          });
          this.onLayoutChange(button, button.dataset.value);
          evt.preventDefault();
        });
      });

      if (this.productLayout && this.productLayout === 'list') {
        const toggle = this.querySelector(`.facets--bar-view-as-button-${this.productLayout}`);
        if (toggle) toggle.click();
      }
    }
    if (this.compareToggle) {
      this.compareToggle.addEventListener('change', this.onCompare);
    }
  }
  onLayoutChange(button, value) {
    button.setAttribute('disabled', '');
    this.productGrid.dataset.layout = value;
    window.localStorage.setItem('product-layout', value);
  }
  onCompare(e) {
    document.body.classList.toggle('compare-true');
    e.preventDefault();
  }
}
customElements.define('facet-toolbar', FacetToolbar);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    this.slider = this.querySelector('.price_slider');
    this.amounts = this.querySelector('.price_slider_amount');
    this.form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    this.inputEvent = new CustomEvent('input');

    const args = {
      start: [
        parseFloat(this.slider.dataset.minValue || 0),
        parseFloat(this.slider.dataset.maxValue || this.slider.dataset.max)
      ],
      connect: true,
      step: 10,
      direction: document.dir,
      handleAttributes: [
        { 'aria-label': 'lower' },
        { 'aria-label': 'upper' },
      ],
      range: {
        'min': 0,
        'max': parseFloat(this.slider.dataset.max)
      }
    };
    noUiSlider.create(this.slider, args);

    this.slider.noUiSlider.on('update', this.onSliderUpdate.bind(this));
    this.slider.noUiSlider.on('change', this.onSliderChange.bind(this));

  }
  onSliderUpdate(values) {
    this.amounts.querySelector('.field__input_min').value = values[0];
    this.amounts.querySelector('.field__input_max').value = values[1];
  }

  onSliderChange(values) {
    this.form.querySelector('form').dispatchEvent(this.inputEvent);
  }
}
customElements.define('price-slider', PriceSlider);

/**
 * Calzados Modesto® — aplicar el filtro de stock al cargar la página y cada
 * vez que cambie el listado (paginación, "cargar más", filtros).
 */
(function () {
  const ejecutarFiltro = () => {
    try { FacetFiltersForm.applyAvailabilityFilter(); } catch (e) {}
  };

  // Varias pasadas en la carga inicial por si las tarjetas tardan en pintarse
  const ejecutarConReintentos = () => {
    ejecutarFiltro();
    setTimeout(ejecutarFiltro, 100);
    setTimeout(ejecutarFiltro, 400);
    setTimeout(ejecutarFiltro, 800);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ejecutarConReintentos);
  } else {
    ejecutarConReintentos();
  }

  // Vigilar el contenedor del listado; se reintenta hasta 50 veces si aún no existe
  let intentos = 0;
  const initObserver = () => {
    const grid = document.getElementById('ProductGridContainer');
    if (!grid) {
      if (intentos++ < 50) setTimeout(initObserver, 200);
      return;
    }
    new MutationObserver(ejecutarFiltro).observe(grid, { childList: true, subtree: true });
  };
  initObserver();
})();
